<template>
  <div>
    <div class="text-center">
      <!-- <div>{{month}}</div>
      <v-btn @click="test">
        test
      </v-btn> -->
      <v-dialog v-if="expireAllcCoin" v-model="dialog" width="500">
        <!-- <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="red lighten-2"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Click Me
        </v-btn>
      </template> -->

        <div style="background-color: #ff616d; padding: 15px">
          แจ้งเตือนคะแนนหมดอายุ
        </div>
        <div style="background-color: white; padding: 15px">
          Coin ที่จะหมดอายุเดือนหน้า
          <div>{{ expireAllcCoin + " Coin" }}</div>
        </div>
        <v-card-actions style="background-color: white">
          <v-spacer></v-spacer>
          <v-radio-group v-model="b">
            <v-radio label="ไม่แสดงรายการนี้อีก" value="Yes"> </v-radio>
          </v-radio-group>
          <v-btn color="primary" text @click="dialog = false, checkNotify()"> I accept </v-btn>
        </v-card-actions>
      </v-dialog>
    </div>
    <!-- <transition name="fade-slide"> -->
    <header-profile></header-profile>
    <!-- </transition> -->
    <!-- <v-divider></v-divider> -->
    <!-- <treding-week></treding-week> -->
    <v-overlay :value="overlay">
     <v-progress-circular
        indeterminate
        size="64"
        color="#F3E9DD"
      ></v-progress-circular>
    </v-overlay>
    <transition name="fade" v-if="member">
      <section style="background-color: white;">
        <div  :style="';height:50px;width:100%;border-radius: 0px;background-image: linear-gradient(179deg,' + $bgColor + '0%,' + $bgColor2 + '100%);'">
          <v-row no-gutters>
            <v-col class="pl-4 font18 pt-3" style="color: white; display: flex">
              <div
                class="pb-0 mr-3"
                :style="
                  'color:' + $textcolor + ' ;font-weight: bold;'
                "
              >
              {{ $t("message.promotion") }}
              </div>
              <v-icon class="iconify" data-icon="fxemoji:megaphone"></v-icon
            ></v-col>
            <v-col
              class="text-end pr-3 font14 link pt-3"
              :style="'color:' + $textcolor + ';justify-content: flex-end;align-items: center;display: flex;'"
              @click="$router.push('promotion')"
              >{{ $t("message.viewAll") }}
              <v-icon :style="'color:' + $textcolor">mdi-chevron-right</v-icon>
            </v-col>
          </v-row>
        </div>
          <promotion-home class="component"></promotion-home>
      </section>
    </transition>
    <section style="background-color: white;position: relative;" v-if="member">
      <div :style="'box-shadow: 0 5px 5px 0px ' + $bgColor2 + ';height:50px;width:100%; border-bottom-left-radius: 0px; border-bottom-right-radius: 0px;background-image: linear-gradient(180deg,' + $bgColor + '0%,' + $bgColor2 + '100%);'">
        <v-row no-gutters>
          <v-col class="pl-4 font18 pt-3" style="display:flex;"><div :style="'color:' + $textcolor + ';font-weight: bold;'"
           class="pb-0 mr-3">{{ $t("message.reward") }}</div>  <v-icon class="iconify" data-icon="noto:wrapped-gift"></v-icon></v-col>
          <v-col
            class="text-end pr-2 font14 link pt-3"
            :style="'color:' + $textcolor + ';justify-content: flex-end;align-items: center;display: flex;'"
            @click="$router.push('reward')"
            >{{ $t("message.viewAll") }} <v-icon :style="'color:' + $textcolor">mdi-chevron-right</v-icon>
          </v-col>
        </v-row>
      </div>
      <most-popular class="component" ></most-popular>
    </section>
  </div>
</template>
<style scoped>
.btnActive {
  border: 2px solid #871b12;
}
</style>
<script>
import HeaderProfile from '../HeaderProfile'
import MostPopular from '../MostPopular'
import TrendingWeek from '../TrendingWeek'
import PromotionHome from '../PromotionHome'
import BlogHome from '../BlogHome'
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
// import moment from 'moment'

export default {
  name: 'Dashboard',
  components: {
    'header-profile': HeaderProfile,
    'most-popular': MostPopular,
    'treding-week': TrendingWeek,
    'promotion-home': PromotionHome,
    'blog-home': BlogHome
  },
  data () {
    return {
      pageTitle: 'My Open Graph Title',
      pageImage: 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/reward/16778746camping-logo-vector-31342377.jpg',
      selection: 0,
      chkShow: '',
      overlay: true,
      dialog: true,
      b: false,
      expireAllcCoin: null,
      dataButton: [
        { text: 'รางวัลสุดฮิต', icon: 'mdi-hexagram-outline', n: 1 },
        { text: 'โปรโมชั่น', icon: 'mdi-bullhorn-outline', n: 2 },
        { text: 'บทความ', icon: 'mdi-web', n: 3 }
      ],
      items: null,
      memberId: null,
      DateNow: new Date(),
      shopId: null,
      profile: null,
      member: null,
      theme: null,
      month: null,
      show: false,
      shopData: null,
      orderId: 'your_order_id_here', // กำหนด order_id หรือดึงจาก data
      amount: 13.00,
      paymentMethod: 'card'
    }
  },
  watch: {
    GET_MEMBERINFO (val) {
      if (val) {
        this.member = val
      } else {
      }
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted () {
    try {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
      await this.getReward()
      // this.month = moment().format('YYYY-MM')
      // if (this.$route.query.reload === 'true') {
      //   this.$router.replace('/')
      //   location.reload()
      // }
      // await this.chckmember()
      // alert(this.shopId)
      // console.log('gggggg0')
      if (this.GET_MEMBERINFO) {
        this.member = this.GET_MEMBERINFO
      } else {
      }
      this.profile = this.getLiffProfile()
      // console.log('gggggg3', this.profile)

      // ถ้ามี shopId จาก query string ให้ set ลง store ก่อน
      if (this.$route.query.shopId) {
        await this.setShopId(this.$route.query.shopId)
        await this.getShopTheme()
      }
      await this.getMemberProfile()
      this.member = await this.GET_MEMBERINFO()
      this.shopId = this.GET_SHOPID()
      // console.log('gggggg3', this.shopId)
      this.theme = this.GET_THEME()
      // console.log('gggggg3', this.theme)
      // await this.chckmember()
      // if (this.shopData.loyverseStatus === 'True') {
      //   await axios
      //     .post(this.DNS_IP + `/update/loyversPoint/${this.profile.memberId}`)
      //     .then(function (response) {
      //     })
      // }
      // if (this.theme.loyverseStatus === 'True') {
      //   await axios
      //     .post(this.DNS_IP + `/update/loyversPoint/${this.profile.memberId}`)
      //     .then(function (response) {
      //     })
      // }
      if (this.$isTargetShop()) {
        if (this.$route.query.sorce === 'getPointBirthDay') {
          this.$router.push('/C?sorce=getPointBirthDay')
        } else {
          this.$router.push('/C')
        }
        return
      } else if (this.shopId === 'U93c42b54e45cfe584473c03e35746955') {
        this.$router.push('/DemoUI2')
        return
      } else if (this.shopId === 'U9793e097e632d954bced75f0ad3610d2') {
        if (this.$route.query.sorce === 'getPointBirthDay') {
          this.$router.push('/CLYN?sorce=getPointBirthDay')
        } else {
          this.$router.push('/CLYN')
        }
        // this.$router.push('/CLYN')
        return
      }
      if (this.shopId !== undefined) {
        if (this.$route.query.fromRegister !== 'already') {
          await this.chkName()
        }
        // await this.getReward()
        // await this.getTheme()
        await this.getCoinExpireNoti()
        this.overlay = false
      } else {
        this.$router.push('/MemberShop?redirectUrl=/home')
      }
      await this.transactionVisitPage()
      window.scrollTo(0, 0)
      this.show = true
      // await this.checkQrcode()
      // let memberId = this.profile.memberId
      // this.firestore = this.$firebase.firestore()
      // this.firestore.collection('PointRealTime').doc(memberId).onSnapshot(async(snapshot) => {
      //   if (!snapshot.exists) {
      //     console.log('Create Newdata')
      //   } else {
      //     console.log('Update')
      //   }
      // }).catch((error) => {
      //   console.error('Error getting document:', error);
      // })
      // if (this.shopId !== 'SD_1770104911502' & this.shopId !== 'U93c42b54e45cfe584473c03e35746955' && this.shopId !== 'U9793e097e632d954bced75f0ad3610d2') {
      // await this.getMemberProfile()
      // }
    } catch (error) {
      console.error('error home', error)
    }
    // this.shopData = this.GET_THEME()
    // if (this.shopData.loyverseStatus === 'True') {
    //   await axios
    //     .post(this.DNS_IP + `/update/loyversPoint/${this.profile.memberId}`)
    //     .then(function (response) {
    //     })
    // }
  },
  computed: {
    metaInfo () {
      return {
        meta: [
          {
            property: 'og:title',
            content: this.pageTitle
          },
          {
            property: 'og:image',
            content: this.pageImage
          }
        ]
      }
    },
    trrr () {
      return this.GET_MEMBERINFO()
    }
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapActions('lineStore', ['setProfile']),
    ...mapActions('memberStore', ['getMemberProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID', 'GET_THEME']),
    ...mapActions('shopStore', ['setShopId', 'getShopTheme']),

    // async chckmember () {
    //   this.member = await this.callBeTaskAPI('get', '/memberCard/line/get?shopId=' + this.$route.query.shopId + '&liffUserId=' + this.profile.userId)
    //   this.member.status === false ? this.findUser = false : this.findUser = true
    //   if (!this.findUser) {
    //     const redirectUrl = encodeURIComponent(currentUrl + window.location.search)
    //     this.$router.push(`/RegisterMember?shopId=${this.shopId}&redirectUrl=${redirectUrl}`)
    //   }
    // },
    handlePayment () {
      // สามารถทำการบันทึกข้อมูล หรือการจัดการการชำระเงินได้ที่นี่
      // ตัวอย่าง เช่นเรียกใช้ฟังก์ชันที่ KBank Payment UI สั่งให้ทำการชำระเงิน
    },
    async chkName () {
      console.log('chkName', this.member)
      if (!this.member) {
        // ไม่มี member → ยังไม่ได้สมัคร → ไป RegisterMember
        const currentUrl = window.location.pathname
        const redirectUrl = encodeURIComponent(currentUrl + window.location.search)
        this.$router.push(`/RegisterMember?shopId=${this.shopId}&redirectUrl=${redirectUrl}`)
        return
      }
      // เช็คว่ามีข้อมูล firstname หรือ nameCustomer หรือไม่
      if ((!this.member.firstname || this.member.firstname === '') &&
          (!this.member.nameCustomer || this.member.nameCustomer === '')) {
        const currentUrl = window.location.pathname
        const redirectUrl = encodeURIComponent(currentUrl + window.location.search)
        this.$router.push(`/RegisterMember?shopId=${this.shopId}&memberId=${this.member.memberId || ''}&redirectUrl=${redirectUrl}`)
      }
    },
    async getCoinExpireNoti () {
      try {
        const params = {
          lineUserId: this.profile.userId,
          shopId: this.shopId
        }
        const result = await this.callBeTaskAPI('get', `/get-expire-coin-by-useId/get`, params)
        if (result.length > 0) {
          this.expireAllcCoin = result.reduce(
            (prev, cur) => parseInt(prev) + parseInt(cur.details),
            0
          )
        }
      } catch (err) {
        console.error(err)
      }
    },
    async checkNotify () {
      if (this.b === 'Yes') {
        await axios.post(this.DNS_IP + `/checkDontShow/update?lineUserId=${this.profile.userId}&shopId=${this.shopId}`, { headers: {lineUserId: this.profile.userId, lineId: this.profile.userId, shopId: this.shopId} })
      } else {
        this.dialog = false
      }
    },
    async getReward () {
      try {
        // const params = {
        //   shopId: this.shopId,
        //   RECORD_STATUS: 'N',
        //   quota: 0
        // }
        const result = await this.callBeTaskAPI('get', `/reward/line/get?trending=True&quota=0&RECORD_STATUS=N`)
        // axios.get(this.DNS_IP + `/reward/line/get?trending=True&quota=0&RECORD_STATUS=N`, { headers: {lineUserId: this.profile.userId, lineId: this.profile.userId, shopId: this.shopId} }).then(a => result = a.data)
        if (result.length > 0) {
          this.items = result
        }
      } catch (err) {
        console.error(err)
      }
    },
    async transactionVisitPage () {
      try {
        const shopId = (this.member && this.member.shopId) || this.$route.query.shopId || this.shopId
        const createUser = this.member && this.member.lineUserId

        const result = await this.callBeTaskAPI(
          'post',
          `/TransactionVisitPage/add`, {
            page: 'Home',
            shopId: shopId,
            CREATE_USER: createUser
          }
        )
        if (result) {
        }
      } catch (err) {
        console.error('err', err)
      }
    }
  }
}
</script>
<style scoped>
/* .wave{
  position: absolute;
  z-index: 0;
}
.component{
  z-index: 1;
}
.wave{
  position: absolute;
  z-index: 0;
} */

</style>



// WEBPACK FOOTER //
// src/components/Home/Home.vue